import { queryKeys } from '@query/keys'
import { usePaginatedQuery } from '@query/usePaginatedQuery'

import { PageQuery, useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { RewardsHubRewardsHistoryDto } from '@model/RewardsHubRewardsHistoryDto'

export const useRewardsHistory = (
  query?: PageQuery
): {
  rewardsHistory: RewardsHubRewardsHistoryDto[]
  isLoading: boolean
} => {
  const apiClient = useApiClient(ClientApiClient)

  const paginatedQuery = usePaginatedQuery<RewardsHubRewardsHistoryDto>({
    queryKey: [...queryKeys.rewardsHub.rewardsHistory(), query],
    queryFn: () => apiClient.getRewardsHubRewardsHistory(query),
  })

  return { rewardsHistory: paginatedQuery.data ?? [], isLoading: paginatedQuery.isLoading }
}
